//This function will accept datetime and return the school year in [YYYY-YYYY] format

export const getSchoolYears = async(date = new Date()) => {
  console.log("tes tin ")
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date");
  }

  let res = {};

  const year = date.getFullYear();
  const aug1 = new Date(year, 7, 1); // August 1

  if (date >= aug1) {
    res["startYear"] = year;
    res["endYear"] = year + 1;
    res["academicYear"] = year + 1;
    res["startDate"] = aug1;
    res["endDate"] = new Date(year + 1, 6, 31); // July 31 next year
  } else {
    res["startYear"] = year - 1;
    res["endYear"] = year;
    res["academicYear"] = year;
    res["startDate"] = new Date(year - 1, 7, 1); // August 1 last year
    res["endDate"] = new Date(year, 6, 31); // July 31 this year
  }

  return res;
};
